import { useTranslation } from 'react-i18next';
import { useCounterSocket } from '@/features/apt-counter/useCounterSocket';
import { TENANT } from '@/routing/tenant';

export function PublicCounterPage() {
  const { t } = useTranslation();
  // The clinic comes from the URL's first segment, not a route param: this page
  // lives at `/<slug>/p/counter`, so the router's basename has already taken it.
  // The server accepts a slug or an id here and resolves either to the channel
  // the counter actually broadcasts on.
  const { state, status } = useCounterSocket(TENANT.slug);

  if (status === 'error') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6 text-center">
        <div>
          <div className="text-2xl font-semibold text-ink">{t('publicCounter.displayUnavailable')}</div>
          <div className="mt-2 text-[14px] text-muted">{t('publicCounter.linkInvalid')}</div>
        </div>
      </div>
    );
  }

  if (!state) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-background text-ink">
      <header className="px-6 pt-6 text-center sm:px-10 sm:pt-10">
        <div className="text-[13px] uppercase tracking-[0.18em] text-muted">
          {state.clinicName}
        </div>
        {status === 'reconnecting' && (
          <div className="mt-1 text-[11px] text-muted">{t('publicCounter.reconnecting')}</div>
        )}
      </header>

      <main className="flex flex-1 flex-col items-center justify-center px-6 pb-10 text-center">
        {state.doctorIn ? (
          <>
            <div className="text-[14px] uppercase tracking-[0.2em] text-muted sm:text-base">
              {t('publicCounter.nowServing')}
            </div>
            <div
              className="mt-3 font-semibold tabular-nums leading-none tracking-tight text-ink"
              style={{ fontSize: 'clamp(8rem, 38vw, 28rem)' }}
              aria-live="polite"
            >
              {state.currentNumber}
            </div>
            {state.doctorName && (
              <div
                className="mt-6 text-muted"
                style={{ fontSize: 'clamp(1.25rem, 3.5vw, 2rem)' }}
              >
                {state.doctorName}
              </div>
            )}
          </>
        ) : (
          <div
            className="font-semibold text-muted"
            style={{ fontSize: 'clamp(2.5rem, 9vw, 6rem)' }}
            aria-live="polite"
          >
            {t('publicCounter.doctorOut')}
          </div>
        )}
      </main>
    </div>
  );
}
